module.exports = __webpack_public_path__ + "static/media/tk.fce85915.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tk.svg
// module id = 265
// module chunks = 0